import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        competitions: [],
        seasons: {}, // کلید: competitionId، مقدار: آرایه‌ی فصل‌ها
        standings: {}, // کلید: "competitionId-seasonId"، مقدار: آرایه‌ی جدول
        matches: {}
    },
    getters: {
        competitions: state => state.competitions,
        seasons: state => (competitionId) => state.seasons[competitionId] || [],
        standings: state => (competitionId, seasonId) => state.standings[`${competitionId}-${seasonId}`] || [],
        matches: state => id => state.matches[id] || []
    },
    mutations: {
        SET_COMPETITIONS(state, competitions) {
            state.competitions = competitions;
        },
        SET_SEASONS(state, {competitionId, seasons}) {
            state.seasons[competitionId] = seasons;
        },
        SET_STANDINGS(state, {competitionId, seasonId, rows}) {
            state.standings[`${competitionId}-${seasonId}`] = rows;
        },
        SET_MATCHES(state, {id, matches}) {
            state.matches[id] = matches;
        }
    },
    actions: {
        async fetchCompetitions({state, commit}) {
            if (state.competitions.length) return;
            const res = await axios.get('/api/competition');
            commit('SET_COMPETITIONS', res.data);
        },
        async fetchSeasons({commit}, competitionId) {
            const res = await axios.get(`/api/competition/${competitionId}/seasons`);
            commit('SET_SEASONS', {competitionId, seasons: res.data});
            return res.data;
        },
        async fetchStandings({commit, state}, {competitionId, seasonId}) {
            const key = `${competitionId}-${seasonId}`;
            console.log('🔍 fetchStandings called for key:', key);

            // اگر قبلاً در استور هست، آن را برگردان
            if (state.standings[key]) {
                console.log('✅ Returning cached data for:', key);
                return state.standings[key];
            }

            console.log('🌐 Making API call for:', key);
            const res = await axios.get(`/api/competition/${competitionId}/season/${seasonId}/standings`);


            console.log('📦 API response:', res);
            console.log('📦 Data length:', res.data?.length || 0);
            console.log('📦 Full data:', res.data);


            commit('SET_STANDINGS', {competitionId, seasonId, rows: res.data});
            return res.data;
        }
    },
});